<div class="cart-slide-area" [class.cart-slide-active]="cartSlide">
  <div class="cart-slide-top">
    <h3>
      <i class="fas fa-shopping-basket"></i> Total Item ({{
      carts.length | numMinDigit
      }})
    </h3>
    <h4 *ngIf="shippingCharge?.freeDeliveryAmount"
      style="background: linear-gradient(to right, rgb(201, 33, 39) 0%, rgb(86, 87, 101) 0%);">Shop
      ৳ {{shippingCharge?.freeDeliveryAmount}} to Enjoy Free Delivery <i class="fa-solid fa-motorcycle"></i></h4>

    <span (click)="onHideCart()"><i class="fa fa-xmark"></i></span>
  </div>


  <div class="cart-slide-main">
    <div class="cart-item-area">
      <div class="worning" *ngIf="this.cartSubTotal && this.cartSubTotal < shippingCharge?.minimumOrderAmount">
        <div class="icon">
          <i class="fas fa-exclamation"></i>
        </div>
        <div class="massage-text">
          <p class="massage">Please order at least <b>{{shippingCharge?.minimumOrderAmount}}</b>৳</p>
          <a href="/product-list" routerLink="/product-list" class="by-more">Buy more</a>
        </div>
      </div>

      <div class="cart-item" *ngFor="let data of carts; index as i">
        <div class="cart-img">
          <img [src]="data?.product?.images?.[0] ?? './assets/images/placeholder/test.png'" alt="" />

          <h4 class="discount-data" *ngIf="data?.product?.discountAmount && data?.product?.discountType == 2">
            <span class="discount-off">{{ data?.product?.discountAmount }}৳ OFF</span>
          </h4>

          <h4 class="discount-data" *ngIf="data?.product?.discountAmount &&data?.product?.discountType == 1">
            <span class="discount-off">{{ data?.product?.discountAmount }}% = {{data?.product | price : "discountAmount"
              }}৳ OFF</span>
          </h4>
        </div>

        <div class="cart-text">
          <div class="name-title">
            <h4>
              {{ data?.product?.name }}
              {{ data?.product?.milligram ? data?.product?.milligram : "" }}
            </h4>
            <div class="delete-item" (click)="
              onDeleteCartItem(data?._id, data?.product?._id, data.priceId)
            ">
              <span><i class="fa-solid fa-xmark"></i></span>
            </div>
          </div>

          <span>({{ data?.unit }}) - ৳
            {{ data?.product | price : "salePrice" }}</span>
          <span>Type :
            {{
            data?.product?.type?.name ? data?.product?.type?.name : "-"
            }}</span>

          <div class="quantity-price">
            <div class="quantity">
              <div>
                <button (click)="onDecrementQty($event, data?._id, i, cartInput)">
                  <i class="fa fa-minus"></i>
                </button>
              </div>
              <div>
                <input type="text" [value]="data?.selectedQty" readonly #cartInput />
              </div>
              <div>
                <button (click)="onIncrementQty($event, data?._id, i)">
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </div>

            <div class="price" *ngIf="data?.product?.discountAmount>0">
              <del>৳{{
                data?.product | price : "regularPrice" : data?.selectedQty
                }}</del>
            </div>

            <div class="price">
              <b>৳{{
                data?.product | price : "salePrice" : data?.selectedQty
                }}</b>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="cart-details">

      <div class="amount-area">
        <p><span>Subtotal</span><span>৳ {{ cartSubTotalWithoutDiscount| number: '2.2' }}</span></p>
        <p><span>Product Discount</span><span>-৳ {{ cartDiscountAmount | number: '1.2'}}</span></p>

        <!-- <div class="regular-delivery">
          <div class="delivery-type">
            <div class="delivery-link active">
              <div class="delivery-select">
                <i class="fa-solid fa-check"></i>
              </div>
              <p class="regular">{{ shippingCharge?.regularDeliveryText || 'Regular Delivery (Next day)' }} -
                {{shippingCharge?.regularDelivery}} ৳</p>
            </div>
          </div>

          <div class="delivery-type">
            <div class="delivery-link active">
              <div class="delivery-select">
                <i class="fa-solid fa-check"></i>
              </div>
              <p class="regular">{{ shippingCharge?.expressDeliveryText || 'Express Delivery (1-4 hours)' }} -
                {{shippingCharge?.expressDelivery}} ৳</p>
            </div>
          </div>
          <div class="delivery-type">
            <div class="delivery-link active">
              <div class="delivery-select">
                <i class="fa-solid fa-check"></i>
              </div>
              <p class="regular">{{ shippingCharge?.superFastDeliveryText || 'Super Fast Delivery (45 mins)' }} -
                {{shippingCharge?.superFastDelivery}} ৳</p>
            </div>
          </div>
          <div class="delivery-type">
            <div class="delivery-link active">
              <div class="delivery-select">
                <i class="fa-solid fa-check"></i>
              </div>
              <p class="regular">{{ shippingCharge?.deliveryOutsideDhakaText || 'Outside Dhaka (2-3 days)' }} -
                {{shippingCharge?.deliveryOutsideDhaka}} ৳</p>
            </div>
          </div>

        </div> -->
        <p class="total-amount">
          <span>Amount Payable</span><span>৳ {{ grandTotal | number: '2.2'}}</span>
        </p>
      </div>


      <div class="discount-area"
        [style.display]="(!(cartSubTotal < orderOffer?.amountOrderMinAmount) && !(cartSubTotal < orderOffer?.amount2OrderMinAmount)  && !(cartSubTotal < orderOffer?.amount3OrderMinAmount) && !(cartSubTotal < orderOffer?.monthOrderValue) )   ? 'none' : 'block'">

        <div class="discount-area-content" *ngIf="cartSubTotal < orderOffer?.amountOrderMinAmount">
          <p>
            <strong>Get {{orderOffer?.amountOrderDiscountAmount}}{{ orderOffer?.amountOrderDiscountType === 1 ? '%' :
              '৳'}}
              : </strong>
            <span>For purchasing above ৳ {{orderOffer?.amountOrderMinAmount}} +</span>
          </p>
        </div>

        <div class="discount-area-content" *ngIf="cartSubTotal < orderOffer?.amount2OrderMinAmount">
          <p>
            <strong>Get {{orderOffer?.amount2OrderDiscountAmount}}{{ orderOffer?.amount2OrderDiscountType === 1 ? '%' :
              '৳'}}
              : </strong>
            <span>For purchasing above ৳ {{orderOffer?.amount2OrderMinAmount}} +</span>
          </p>
        </div>

        <div class="discount-area-content" *ngIf="cartSubTotal < orderOffer?.amount3OrderMinAmount">
          <p>
            <strong>Get {{orderOffer?.amount3OrderDiscountAmount}}{{ orderOffer?.amount3OrderDiscountType === 1 ? '%' :
              '৳'}}
              : </strong>
            <span>For purchasing above ৳ {{orderOffer?.amount3OrderMinAmount}} +</span>
          </p>
        </div>
        <div class="discount-area-content" *ngIf="cartSubTotal < orderOffer?.monthOrderValue">
          <p>
            <strong>Get {{orderOffer?.monthOrderDiscountAmount}}{{ orderOffer?.monthOrderDiscountType === 1 ? '%' :
              '৳'}}
              : </strong>
            <span>For purchasing above ৳ {{orderOffer?.monthOrderValue}} +</span>
          </p>
        </div>

      </div>


    </div>
  </div>


  <div class="cart-slide-bottom">
    <button class="checkout-btn" (click)="cartToOrderCart()">
      <p>Proceed To Checkout</p>
      <span>৳{{ grandTotal | number: '2.2'}}</span>
    </button>
  </div>
</div>

<div class="overlay" (click)="onHideCart()" [class.active]="cartSlide"></div>
<!-- END! overlay -->